import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { classNames } from 'uitk-react-utils';
import { UitkExpandoListItem } from 'uitk-react-expando';

interface ExpandoProps extends React.AllHTMLAttributes<HTMLDListElement> {
  callToActionText: string;
  expandedText: string | undefined;
  rfrr: string;
  analyticsDescription: string;
}

interface InjectedExpandoProps {
  analytics: AnalyticsStore;
}

export const Expando: React.FC<ExpandoProps> = inject('analytics')(
  ({ callToActionText, expandedText, rfrr, analytics, analyticsDescription, className, ...props }: ExpandoProps & InjectedExpandoProps) => {
    if (!expandedText || !callToActionText) {
      return null;
    }

    const [isVisible, setIsVisible] = React.useState(false);
    const toggle = React.useCallback(() => setIsVisible(!isVisible), [isVisible]);
    const faqAnalytics = analytics.setupTracker(`${rfrr}.${isVisible ? 'close' : 'open'}`, analyticsDescription);

    return (
      <UitkExpandoListItem
        isVisible={isVisible}
        expandoTitle={callToActionText}
        expandoDescription={<div className={classNames(className)} dangerouslySetInnerHTML={{ __html: expandedText }} />}
        handleClick={toggle}
        analytics={faqAnalytics}
        {...props}
      />
    );
  }
);

Expando.displayName = 'Expando';
